import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import { queryClient } from "services/api/apiHelper";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "styles/theme";
import "styles/globals.css";
import "./libs/i18n";
import Pages from "pages";
import { BrowserRouter } from "react-router-dom";
import { BASE_PATH } from "utils/constants";

const RenderDevTool = () =>
  process.env.NODE_ENV === "development" ? <ReactQueryDevtools initialIsOpen={false} /> : null;

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <Toaster position="bottom-center" />
        <BrowserRouter basename={BASE_PATH}>
          <Pages />
        </BrowserRouter>
        <RenderDevTool />
      </ChakraProvider>
    </QueryClientProvider>
  );
}
